import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import font from 'next/font/google/target.css?{"path":"src/pages/_app.tsx","import":"Lexend","arguments":[{"subsets":["latin"]}],"variableName":"font"}';
"skip ssr";
import _default from "react";
import "prismjs/themes/prism-tomorrow.css";
import "website/src/styles/index.css";
import { SessionContextProvider } from "@supabase/auth-helpers-react";
import { useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { DashboardContainer } from "website/src/components/DashboardContainer";
import NextNprogress from "nextjs-progressbar";
import { NextUIProvider } from "@nextui-org/react";
import Script from "next/script";
import { Toaster } from "react-hot-toast";
import classNames from "classnames";
import { createPagesBrowserClient } from "@supabase/auth-helpers-nextjs";
import { dashboardContext } from "website/src/lib/hooks";
import { useRouter } from "next/router";
function MyApp(param) {
  let {
    Component,
    pageProps: {
      session,
      ...pageProps
    }
  } = param;
  const router = useRouter();
  const isDashboard = router.asPath.startsWith("/org/");
  const is404 = (pageProps === null || pageProps === void 0 ? void 0 : pageProps["statusCode"]) > 200;
  if (Component.disableNprogress) {
    pageProps.disableNprogress = true;
  }
  if (is404) {
    return /*#__PURE__*/_jsx(CommonProviders, {
      pageProps: pageProps,
      children: /*#__PURE__*/_jsx(Component, {
        ...pageProps
      })
    });
  }
  if (isDashboard) {
    return /*#__PURE__*/_jsx(CommonProviders, {
      pageProps: pageProps,
      children: /*#__PURE__*/_jsx(dashboardContext.Provider, {
        value: pageProps,
        children: /*#__PURE__*/_jsx(DashboardContainer, {
          children: /*#__PURE__*/_jsx(Component, {
            ...pageProps
          }, router.asPath)
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(CommonProviders, {
    pageProps: pageProps,
    children: /*#__PURE__*/_jsx(Component, {
      ...pageProps
    })
  });
}
function CommonProviders(param) {
  let {
    children,
    pageProps
  } = param;
  const [supabase] = useState(() => createPagesBrowserClient({}));
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(font.className, "w-full h-full"),
    children: [/*#__PURE__*/_jsx(Analytics, {}), /*#__PURE__*/_jsx(SessionContextProvider, {
      supabaseClient: supabase,
      initialSession: pageProps.initialSession,
      children: /*#__PURE__*/_jsxs(NextUIProvider, {
        children: [/*#__PURE__*/_jsx(Script, {
          async: true,
          src: "https://cdn.splitbee.io/sb.js"
        }), !pageProps.disableNprogress && /*#__PURE__*/_jsx(NextNprogress, {
          color: "#f59e0b",
          startPosition: 0.3,
          stopDelayMs: 200,
          height: 4,
          options: {
            showSpinner: false
          },
          showOnShallow: true
        }), /*#__PURE__*/_jsx(Toaster, {
          containerStyle: {
            zIndex: 10000
          },
          position: "top-center"
        }), children]
      })
    })]
  });
}
function DefaultExportRenamedByElacca(props) {
  const [isMounted, setIsMounted] = _default.useState(false);
  _default.useEffect(() => {
    setIsMounted(true);
  }, []);
  return isMounted ? /*#__PURE__*/_default.createElement(MyApp, props) : null;
}
Object.assign(DefaultExportRenamedByElacca, MyApp);
export default DefaultExportRenamedByElacca;